<mat-toolbar color="primary">
  <span>
    <button mat-button routerLink="/">
      <mat-icon>home</mat-icon>
    </button>
    <button mat-button routerLink="/">{{ title }}</button>
  </span>
  <span class="fill-space"></span>
</mat-toolbar>
